"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AgeGate = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styles = require("./styles");
var _bricksTheme = _interopRequireDefault(require("@titelmedia/bricks-theme"));
var _bricksUtils = require("@titelmedia/bricks-utils");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const AgeGate = ({
  logo,
  title,
  yesMessage,
  noMessage,
  redirectLink,
  colorMode,
  backgroundColor
}) => {
  const containerRef = (0, _react.useRef)(null);
  const [visible, setVisible] = (0, _react.useState)(true);
  const fluid = logo?.fluid || logo?.responsiveImage || logo;
  const tl = _bricksUtils.gsap.timeline();
  (0, _react.useEffect)(() => {
    if (visible === true) {
      if (_bricksUtils.ScrollSmoother?.get()) {
        _bricksUtils.ScrollSmoother.get().paused(true);
      }
      _bricksUtils.gsap.set(document.body, {
        overflow: 'hidden'
      });
      tl.set(containerRef.current, {
        opacity: 1
      });
    }
  }, []);
  const redirectToHomepage = () => {
    window.location.href = redirectLink || 'https://www.highsnobiety.com';
  };
  const closeAgeGate = () => {
    tl.reveal(containerRef.current, {
      delay: 0.5,
      duration: 0.25
    }).add(enableScroll).set(document.body, {
      overflow: 'auto'
    });
  };
  const enableScroll = () => {
    if (_bricksUtils.ScrollSmoother?.get()) {
      _bricksUtils.ScrollSmoother.get().paused(false);
    }
    setVisible(false);
  };
  return _react.default.createElement(_react.default.Fragment, null, visible === true && _react.default.createElement(_styles.Container, {
    ref: containerRef,
    background: backgroundColor?.hex || backgroundColor,
    className: "age-gate"
  }, _react.default.createElement(_styles.Content, null, _react.default.createElement(_bricksTheme.default, null), fluid && _react.default.createElement(_styles.Image, {
    srcSet: fluid.srcSet,
    src: fluid.src
  }), _react.default.createElement(_styles.Title, {
    colorMode: colorMode
  }, title), _react.default.createElement(_styles.ButtonsContainer, {
    colorMode: colorMode
  }, _react.default.createElement(_styles.Button, {
    onClick: closeAgeGate
  }, yesMessage), _react.default.createElement(_styles.Button, {
    onClick: redirectToHomepage
  }, noMessage)))));
};
exports.AgeGate = AgeGate;
//# sourceMappingURL=index.js.map